import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "linking-input" }
const _hoisted_2 = { class: "linking-input__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "linking-input__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__prefix" }
const _hoisted_6 = { class: "sub-title__suffix" }
const _hoisted_7 = { class: "linking-input__linking-container" }
const _hoisted_8 = { class: "linking-input__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import InputExcelForm from '../inputExcelForm/InputExcelForm.vue';
import { AlterableHeaderInfo } from '../../interfaces/LinkingInput';
import { UNSELECTED_HEADER_VALUE } from '@/registerInputModule/constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'LinkingInput',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');

const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-2.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-2.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-2__en.png') : imagesRequire('./register-input-step-flow-2.png');
  },
  {
    immediate: true,
  }
);

/**
 * 選択されたフィールドを更新する
 * @param header - フィールド
 * @param updateValue - 更新する値
 */
const updateSelectedField = (header: AlterableHeaderInfo, updateValue: string) => {
  // 選択された値を更新
  state.value.linkingInput.alternateHeaderInfos = state.value.linkingInput.alternateHeaderInfos.map((linkedHeader) => {
    if (linkedHeader.header === header.header) {
      // 選択された値が「未選択」の場合は空文字列にする
      return {
        ...linkedHeader,
        value: updateValue !== UNSELECTED_HEADER_VALUE ? updateValue : '',
      };
    }
    return linkedHeader;
  });
};

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadInput.headerCandidates.map((candidate) => candidate.value);
});

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInlineHeaderName = (updateValue: string) => {
  state.value.linkingInput.inlinedYearMonthInfo.headerName = updateValue;
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderStartColumnNumber = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.startColumnNumber = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.startColumnNumber,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderEndColumnNumber = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.endColumnNumber = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.endColumnNumber,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderStart = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.start = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.start,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderEnd = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.end = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.end,
    raw: updateValue,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引紐付け：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "linking-input__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('取引紐付け：本文')), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引紐付け：注釈')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(InputExcelForm, {
        from: 'LinkingInput',
        "selected-field-id": selectedFieldId.value,
        suggestions: selectedFieldSuggestions.value,
        "input-file-type": _unref(state).uploadInput.inputFileType,
        "use-format-type": _unref(state).uploadInput.useFormatType,
        "alterable-header-infos": _unref(state).linkingInput.alternateHeaderInfos,
        "inlined-year-month-info": _unref(state).linkingInput.inlinedYearMonthInfo,
        "in-header-year-month-info": _unref(state).linkingInput.inHeaderYearMonthInfo,
        onUpdateSelectedFieldId: _cache[0] || (_cache[0] = 
          (id) => {
            selectedFieldId.value = id;
          }
        ),
        onUpdateSelectedField: updateSelectedField,
        onUpdateInlineHeaderName: updateInlineHeaderName,
        onUpdateInHeaderStartColumnNumber: updateInHeaderStartColumnNumber,
        onUpdateInHeaderEndColumnNumber: updateInHeaderEndColumnNumber,
        onUpdateInHeaderStart: updateInHeaderStart,
        onUpdateInHeaderEnd: updateInHeaderEnd
      }, null, 8, ["selected-field-id", "suggestions", "input-file-type", "use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：登録ボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})